(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[329],{

/***/ 22085:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seq-consult",
      function () {
        return __webpack_require__(52852);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_seq_consult; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/components/AppLayout/index.tsx + 45 modules
var AppLayout = __webpack_require__(84702);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-hook-form-virtual-e700c25d77/0/cache/react-hook-form-npm-7.36.1-ea95e51e7c-d41951685f.zip/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(46996);
// EXTERNAL MODULE: ./src/di-container/axios.ts
var axios = __webpack_require__(43856);
// EXTERNAL MODULE: ../../shared/remodeling-manager/src/index.ts + 7 modules
var src = __webpack_require__(31376);
;// CONCATENATED MODULE: ./src/di-container/remodeling-manager/seq-consult/gateway/client.ts


var seqConsultGateway = function() {
    return {
        createSeqConsult: new src/* CreateSeqConsultGateway */.zM(axios/* axios */.o)
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/providers/ModalProvider/ModalProvider.tsx + 1 modules
var ModalProvider = __webpack_require__(72244);
// EXTERNAL MODULE: ./src/di-container/remodeling-manager/quick-consult/gateway/client.ts
var client = __webpack_require__(17881);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var dist = __webpack_require__(98749);
// EXTERNAL MODULE: ./src/hooks/useAuthenticated.ts
var useAuthenticated = __webpack_require__(90457);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ./src/constants/seq-consult.ts
var seq_consult = __webpack_require__(20559);
// EXTERNAL MODULE: ./src/hooks/useDataLayer.ts
var useDataLayer = __webpack_require__(55806);
// EXTERNAL MODULE: ./src/constants/gtm.ts
var gtm = __webpack_require__(60625);
// EXTERNAL MODULE: ./src/providers/BrazeProvider/index.tsx + 1 modules
var BrazeProvider = __webpack_require__(53590);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.29.3-fef7e3c72c-e01cf5b62a.zip/node_modules/date-fns/esm/format/index.js + 6 modules
var format = __webpack_require__(22969);
// EXTERNAL MODULE: ./src/di-container/expert/detail/gateway/client.ts
var gateway_client = __webpack_require__(20838);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/hooks/useSeqConsult.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var CONSULT_DATA_MAP = {
    SEQ: seq_consult/* SEQ_CONSULT_DATA */.k_,
    MATCH: seq_consult/* MATCH_CONSULT_DATA */.FL
};
var useSeqConsult = function() {
    var ref, ref1;
    var hookForm = (0,index_esm/* useForm */.cI)({
        mode: "onSubmit"
    });
    var router = (0,next_router.useRouter)();
    var consultType = function() {
        var type = router.query.consultType;
        return type === "MATCH" ? "MATCH" : "SEQ";
    }();
    var channelType = router.query.channelType;
    var channelId = router.query.channelId;
    var channelUrl = router.query.channelUrl;
    var agentEmployeeNo = router.query.agentEmployeeNo;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var handleOpen = (0,ModalProvider/* useModal */.d)().handleOpen;
    var ref2 = (0,react.useState)(false), isOpenWorkableBottomSheet = ref2[0], setIsOpenWorkableBottomSheet = ref2[1];
    var isApiCall = (0,react.useRef)(false);
    var consultData = CONSULT_DATA_MAP[consultType];
    var initialStep = Object.keys(consultData)[0];
    var ref3 = (0,react.useState)(initialStep), step = ref3[0], setStep = ref3[1];
    var totalStepLength = (0,react.useMemo)(function() {
        return Object.keys(consultData).length;
    }, [
        consultData
    ]);
    var currentStepIndex = (0,react.useMemo)(function() {
        var titleKeys = Object.keys(consultData);
        return titleKeys.findIndex(function(_step) {
            return _step === step;
        });
    }, [
        step,
        consultData
    ]);
    var handleChangeStep = (0,react.useCallback)(function(nextStep) {
        setStep(nextStep);
    }, []);
    var checkValidity = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var result, isPassed;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(step === "baseConstructionPlan.scopes")) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 3;
                    return hookForm.trigger("baseConstructionPlan.etcComment");
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                    if (!(step === "personal")) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 7;
                    return Promise.all([
                        hookForm.trigger("name"),
                        hookForm.trigger("tel"),
                        hookForm.trigger("site.addressDetail"), 
                    ]);
                case 7:
                    result = _ctx.sent;
                    isPassed = !result.includes(false);
                    return _ctx.abrupt("return", isPassed);
                case 10:
                    return _ctx.abrupt("return", true);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        step,
        hookForm
    ]);
    var createSeqConsult = seqConsultGateway().createSeqConsult;
    var handlePushAndRemove = (0,useDataLayer/* useDataLayer */.P)().handlePushAndRemove;
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    // 상담 가능 지역 데이터를 가져오는 함수
    var getWorkAvailableAreasFetcher = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var ref, ref1, ref2, ref3, ref4, ref5, apiResponse;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,gateway_client/* expertGateway */.O)().getExpertDetail.exec({
                        agentCode: agentEmployeeNo
                    });
                case 3:
                    apiResponse = _ctx.sent;
                    return _ctx.abrupt("return", {
                        workAvailableAreas: (ref = apiResponse.data) === null || ref === void 0 ? void 0 : ref.agentDetail.workAvailableAreas,
                        agentName: (ref1 = apiResponse.data) === null || ref1 === void 0 ? void 0 : ref1.agentDetail.name,
                        agencyName: (ref2 = apiResponse.data) === null || ref2 === void 0 ? void 0 : ref2.agency.name,
                        agentImageUrl: (ref4 = (ref3 = apiResponse.data) === null || ref3 === void 0 ? void 0 : ref3.agentDetail.image) === null || ref4 === void 0 ? void 0 : ref4.url,
                        agentDuty: (ref5 = apiResponse.data) === null || ref5 === void 0 ? void 0 : ref5.agentDetail.duty
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        agentEmployeeNo
    ]);
    // 전문가 상담일때만 SWR을 사용하여 데이터 가져오기
    var ref4 = (0,dist/* default */.ZP)(channelType === "OP23_01" ? "getWorkAvailableAreas" : null, getWorkAvailableAreasFetcher), expertData = ref4.data;
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var data, isMatchType, response, ref, ref1, ref2, ref3, ref4, ref5, ref6, _obj, sidoCode, sigunguCode, gunguCode;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isApiCall.current) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        isApiCall.current = true;
                        data = hookForm.getValues();
                        isMatchType = consultType === "MATCH";
                        _ctx.next = 8;
                        return createSeqConsult.exec(_objectSpreadProps(_objectSpread({}, data), {
                            name: data.name.trim(),
                            agreement: {
                                privacy: data.agreement.privacy ? "Y" : "N",
                                provide: data.agreement.provide ? "Y" : "N"
                            },
                            baseConstructionPlan: _objectSpread({}, data.baseConstructionPlan),
                            channel: _objectSpread({
                                channelType: channelType,
                                channelId: lodash_default().toNumber(channelId),
                                channelUrl: channelUrl,
                                agentEmployeeNo: agentEmployeeNo,
                                body: expertData === null || expertData === void 0 ? void 0 : expertData.agencyName,
                                thumbUrl: expertData === null || expertData === void 0 ? void 0 : expertData.agentImageUrl
                            }, (expertData === null || expertData === void 0 ? void 0 : expertData.agentName) && (expertData === null || expertData === void 0 ? void 0 : expertData.agentDuty) && {
                                title: "".concat(expertData.agentName, " ").concat(expertData.agentDuty)
                            }),
                            simpleUserAgent: "PC_WEB",
                            consultType: consultType
                        }));
                    case 8:
                        response = _ctx.sent;
                        if ((response === null || response === void 0 ? void 0 : response.code) === 200) {
                            ;
                            ;
                            handlePushAndRemove({
                                data: (_obj = {
                                    event: gtm/* GTM_CTA_REMO_EVENT_NAME */.EK
                                }, _defineProperty(_obj, gtm/* GTM_CTA_KEY_NAME */.H7, gtm/* GTM_CSTC */.Ov), _defineProperty(_obj, "gtmKeyword", isMatchType ? gtm/* GTM_MATCH_CONSULT_KEYNAME */.iL : gtm/* GTM_SEQ_CONSULT_KEYNAME */.vS), _defineProperty(_obj, "consult_request_id", response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id), _defineProperty(_obj, gtm/* GTM_CST_KEYWORD */.Gj, isMatchType ? gtm/* GTM_MATCH_CONSULT_KEYWORD */.vu : gtm/* GTM_SEQ_CONSULT_KEYWORD */.bx), _obj),
                                key: gtm/* GTM_CTA_KEY_NAME */.H7
                            });
                            logCustomEvent({
                                eventName: "bz_complete_fastconsult",
                                eventProperties: {
                                    bz_date: (0,format/* default */.Z)(new Date(), "yyyy-MM-dd"),
                                    bz_consultType: "sequential",
                                    bz_type: data.site.buildingType,
                                    bz_area: data.site.houseNMPG,
                                    bz_state: data.baseConstructionPlan.spaceStatus,
                                    bz_space: (ref1 = data.baseConstructionPlan.scopes) === null || ref1 === void 0 ? void 0 : ref1.join(","),
                                    bz_duedate: data.baseConstructionPlan.desiredDay,
                                    bz_postcode: data.site.address.zoneCode
                                }
                            });
                            sidoCode = data === null || data === void 0 ? void 0 : (ref2 = data.site) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.sidoCode;
                            sigunguCode = data === null || data === void 0 ? void 0 : (ref4 = data.site) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.address) === null || ref5 === void 0 ? void 0 : ref5.sigunguCode;
                            gunguCode = lodash_default().startsWith(sigunguCode, sidoCode) ? lodash_default().replace(sigunguCode, sidoCode, "") : sigunguCode;
                            router.push("/seq-consult/finish?id=".concat((ref6 = response.data) === null || ref6 === void 0 ? void 0 : ref6.id, "&sidoCode=").concat(sidoCode, "&sigunguCode=").concat(gunguCode, "&sidoName=").concat(data.site.address.sidoName, "&sigunguName=").concat(data.site.address.sigunguName));
                        } else if ((response === null || response === void 0 ? void 0 : response.code) === 14199) {
                            handleOpen({
                                modalProps: {
                                    text: "고객님의 연락처로 오늘 자\n상담신청 내역이 이미 존재합니다.",
                                    subtext: "동일한 연락처로 1일 1회 상담신청이 가능합니다.",
                                    subTextAlign: "center"
                                }
                            });
                            isApiCall.current = false;
                        } else {
                            handleOpen({
                                modalProps: {
                                    text: response.message,
                                    subTextAlign: "center"
                                }
                            });
                            isApiCall.current = false;
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        channelId,
        channelType,
        channelUrl,
        createSeqConsult,
        handleOpen,
        handlePushAndRemove,
        hookForm,
        logCustomEvent,
        router,
        agentEmployeeNo,
        expertData,
        consultType, 
    ]);
    var handleNext = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var titleKeys, nextStep, validationPassed, isLastStep;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        titleKeys = Object.keys(consultData);
                        nextStep = titleKeys[currentStepIndex + 1];
                        _ctx.next = 5;
                        return checkValidity();
                    case 5:
                        validationPassed = _ctx.sent;
                        if (validationPassed) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        isLastStep = step === "personal";
                        if (isLastStep && e) {
                            handleSubmit(e);
                        }
                        if (nextStep) {
                            handleChangeStep(nextStep);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        currentStepIndex,
        handleChangeStep,
        checkValidity,
        step,
        handleSubmit,
        consultData, 
    ]);
    var handlePrev = (0,react.useCallback)(function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        var titleKeys = Object.keys(consultData);
        var prevStep = titleKeys[currentStepIndex - 1];
        if (prevStep) {
            handleChangeStep(prevStep);
        }
    }, [
        currentStepIndex,
        handleChangeStep,
        consultData
    ]);
    var getBasic = (0,client/* quickConsultGateway */.r)().getBasic;
    var ref5 = (0,dist/* default */.ZP)(isAuthenticated ? "user-basic-info" : null, function() {
        return getBasic.exec();
    }), userBasicInfoResponse = ref5.data;
    var userBasicInfo = (0,react.useMemo)(function() {
        var ref;
        return userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref = userBasicInfoResponse.data) === null || ref === void 0 ? void 0 : ref.user;
    }, [
        userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref = userBasicInfoResponse.data) === null || ref === void 0 ? void 0 : ref.user
    ]);
    var ref6 = (0,react.useState)("default"), defaultRadio = ref6[0], setIsDefaultRadio = ref6[1];
    var handleChangeIsDefaultAddress = (0,react.useCallback)(function(defaultRadio) {
        setIsDefaultRadio(defaultRadio);
    }, []);
    var stepBannerSrc = (0,react.useMemo)(function() {
        if (step === "baseConstructionPlan.age" || step === "site.buildingType" || step === "site.houseNMPG" || step === "baseConstructionPlan.spaceStatus" || step === "baseConstructionPlan.consultPurpose" || step === "baseConstructionPlan.consultExperience" || step === "baseConstructionPlan.opinionReflect" || step === "baseConstructionPlan.communicationStyle") {
            return (0,utils/* getAsset */.Nh)("/assets/images/seq-consult/seq_consult_banner_1.jpg");
        } else {
            return (0,utils/* getAsset */.Nh)("/assets/images/seq-consult/seq_consult_banner_2.jpg");
        }
    }, [
        step
    ]);
    var ref7 = (0,react.useState)(false), isTelCertificated = ref7[0], setIsTelCertificated = ref7[1];
    var handleChangeTelCertificated = (0,react.useCallback)(function(nextCertificated) {
        setIsTelCertificated(nextCertificated);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref = userBasicInfoResponse.data) === null || ref === void 0 ? void 0 : ref.user) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var address = userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref1 = userBasicInfoResponse.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.site) === null || ref3 === void 0 ? void 0 : ref3.address;
            var addressDetail = userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref4 = userBasicInfoResponse.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.site) === null || ref6 === void 0 ? void 0 : ref6.addressDetail;
            var name = userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref7 = userBasicInfoResponse.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.user) === null || ref8 === void 0 ? void 0 : ref8.name;
            var tel = userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref9 = userBasicInfoResponse.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.user) === null || ref10 === void 0 ? void 0 : ref10.tel;
            hookForm.setValue("site.address", address);
            hookForm.setValue("site.addressDetail", addressDetail);
            hookForm.setValue("name", name);
            hookForm.setValue("tel", tel);
        }
    }, [
        hookForm,
        userBasicInfoResponse === null || userBasicInfoResponse === void 0 ? void 0 : (ref1 = userBasicInfoResponse.data) === null || ref1 === void 0 ? void 0 : ref1.user
    ]);
    (0,react.useEffect)(function() {
        var alertRouting = function() {
            var ref;
            var site = ((ref = hookForm.getValues()) !== null && ref !== void 0 ? ref : {}).site;
            if (step === "site.buildingType" && !(site === null || site === void 0 ? void 0 : site.buildingType)) {
                return;
            }
            window.onbeforeunload = function() {
                return true;
            };
        };
        alertRouting();
        return function() {
            window.onbeforeunload = null;
        };
    }, [
        step,
        hookForm.getValues,
        hookForm
    ]);
    (0,react.useEffect)(function() {
        if (true) {
            window.scrollTo({
                behavior: "smooth",
                top: 0
            });
        }
    }, [
        step
    ]);
    var handleOpenBottomSheet = (0,react.useCallback)(function() {
        setIsOpenWorkableBottomSheet(true);
    }, []);
    var handleCloseBottomSheet = (0,react.useCallback)(function() {
        setIsOpenWorkableBottomSheet(false);
    }, []);
    var stepTitle = (0,react.useCallback)(function(currentStep) {
        var ref;
        var data = consultType === "MATCH" ? seq_consult/* MATCH_CONSULT_DATA */.FL : seq_consult/* SEQ_CONSULT_DATA */.k_;
        var ref1;
        var title = (ref1 = (ref = data[currentStep]) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "";
        var isFirstQuestion = consultType === "MATCH" ? currentStep === "baseConstructionPlan.age" : currentStep === "site.buildingType";
        if (isFirstQuestion && title) {
            return "반갑습니다. 고객님!\n".concat(title);
        }
        return title;
    }, [
        consultType
    ]);
    return {
        hookForm: hookForm,
        step: step,
        stepTitle: stepTitle,
        consultType: consultType,
        currentStepIndex: currentStepIndex,
        totalStepLength: totalStepLength,
        handleChangeStep: handleChangeStep,
        handlePrev: handlePrev,
        handleNext: handleNext,
        handleSubmit: handleSubmit,
        userBasicInfo: userBasicInfo,
        defaultRadio: defaultRadio,
        handleChangeIsDefaultAddress: handleChangeIsDefaultAddress,
        stepBannerSrc: stepBannerSrc,
        isTelCertificated: isTelCertificated,
        handleChangeTelCertificated: handleChangeTelCertificated,
        workAvailableAreas: expertData === null || expertData === void 0 ? void 0 : expertData.workAvailableAreas,
        agentEmployeeNo: agentEmployeeNo,
        isOpenWorkableBottomSheet: isOpenWorkableBottomSheet,
        handleOpenBottomSheet: handleOpenBottomSheet,
        handleCloseBottomSheet: handleCloseBottomSheet
    };
};
/* harmony default export */ var hooks_useSeqConsult = (useSeqConsult);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-e325f5b003/0/cache/@design-system-pc-npm-4.9.4-1fa44413c9-3660566693.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(33025);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
// EXTERNAL MODULE: ./src/components/Grid/index.tsx + 1 modules
var Grid = __webpack_require__(14657);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.2-d2fdae468d-2c62199789.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(38805);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/LoadImage/index.tsx + 1 modules
var LoadImage = __webpack_require__(97119);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/SeqConsultOptionButton.tsx
function SeqConsultOptionButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqConsultOptionButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqConsultOptionButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SeqConsultOptionButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SeqConsultOptionButton_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SeqConsultOptionButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n    border: 0;\n    min-width: 68px;\n    padding: 23px 20px;\n    border-radius: 100px;\n    width: 100%;\n    height: 68px;\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n\n    &.active {\n      & > div {\n        color: ",
        " !important;\n      }\n\n      border: 1px solid ",
        ";\n      background-color: rgba(0, 100, 255, 0.1);\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n    border: 0;\n    outline: none;\n    background-color: transparent;\n    height: 168px;\n    position: relative;\n\n    &::after {\n      content: '';\n      display: none;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border: 1px solid ",
        ";\n    }\n\n    &:hover {\n      &::after {\n        display: block;\n      }\n    }\n\n    .seq-scope-item-photo {\n      display: flex;\n      justify-content: center;\n      height: 128px;\n      overflow: hidden;\n      background-color: ",
        ";\n    }\n\n    .seq-scope-item-title {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 40px;\n    }\n\n    &.active {\n      &::after {\n        display: block;\n        border: 1px solid ",
        ";\n      }\n\n      .seq-scope-item-title {\n        & > div {\n          color: ",
        " !important;\n        }\n        background-color: rgba(0, 100, 255, 0.1);\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var SeqConsultOptionButton = function(_param) {
    var children = _param.children, isActive = _param.isActive, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, imageSrc = _param.imgSrc, props = _objectWithoutProperties(_param, [
        "children",
        "isActive",
        "variant",
        "imgSrc"
    ]);
    var onToggle = (0,react.useCallback)(function(e) {
        e.currentTarget.classList.toggle("active");
    }, []);
    var handleClick = (0,react.useCallback)(function(e) {
        var ref;
        e.preventDefault();
        onToggle(e);
        (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
    }, [
        onToggle,
        props
    ]);
    if (variant === "photo") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhotoButton, SeqConsultOptionButton_objectSpreadProps(SeqConsultOptionButton_objectSpread({
            "data-cypress-element": true
        }, props), {
            onClick: handleClick,
            className: classnames_default()({
                active: isActive
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    className: "seq-scope-item-photo",
                    children: imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                        style: {
                            width: "auto",
                            maxWidth: "initial",
                            flexShrink: "0",
                            flexGrow: "1"
                        },
                        src: (0,utils/* getAsset */.Nh)(imageSrc)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    className: "seq-scope-item-title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                        variant: "subTitle6",
                        color: "color_chip.primary",
                        children: children
                    })
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionButton, SeqConsultOptionButton_objectSpreadProps(SeqConsultOptionButton_objectSpread({
        "data-cypress-element": true
    }, props), {
        onClick: handleClick,
        className: classnames_default()({
            active: isActive
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
            variant: "subTitle6",
            color: "color_chip.primary",
            children: children
        })
    }));
};
/* harmony default export */ var SeqConsult_SeqConsultOptionButton = (SeqConsultOptionButton);
var OptionButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SeqConsultOptionButton__OptionButton",
    componentId: "sc-caff92ed-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.colors.color_chip.gray[50], theme.colors.color_chip.gray[50], theme.colors.color_chip.gray[700], theme.colors.color_chip.blue[500], theme.colors.color_chip.blue[500]);
});
var PhotoButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "SeqConsultOptionButton__PhotoButton",
    componentId: "sc-caff92ed-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.colors.color_chip.gray[700], theme.colors.color_chip.gray[50], theme.colors.color_chip.blue[500], theme.colors.color_chip.blue[500]);
});

;// CONCATENATED MODULE: ./src/providers/SeqConsultProvider/SeqConsultProvider.tsx
function SeqConsultProvider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqConsultProvider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqConsultProvider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var SeqConsultContext = /*#__PURE__*/ (0,react.createContext)({});
var useSeqConsultContext = function() {
    var context = (0,react.useContext)(SeqConsultContext);
    if (context === undefined) {
        throw new Error("useSeqConsultFormContext must be used within a SeqConsultContext");
    }
    return context;
};
var SeqConsultProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsultContext.Provider, {
        value: SeqConsultProvider_objectSpread({}, value),
        children: children
    });
};
/* harmony default export */ var SeqConsultProvider_SeqConsultProvider = ((/* unused pure expression or super */ null && (SeqConsultProvider)));

;// CONCATENATED MODULE: ./src/providers/SeqConsultProvider/index.ts



// EXTERNAL MODULE: ./src/providers/PopupProvider/PopupProvider.tsx + 1 modules
var PopupProvider = __webpack_require__(42677);
// EXTERNAL MODULE: ./src/components/AgreementPopup/PersonalInfoCollection.tsx
var PersonalInfoCollection = __webpack_require__(79242);
// EXTERNAL MODULE: ./src/components/AgreementPopup/ThirdParties.tsx
var ThirdParties = __webpack_require__(96411);
// EXTERNAL MODULE: ../../.yarn/cache/uuid-npm-9.0.0-46c41e3e43-8dd2c83c43.zip/node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(54106);
// EXTERNAL MODULE: ../../shared/common/src/index.ts + 9 modules
var common_src = __webpack_require__(61462);
;// CONCATENATED MODULE: ./src/di-container/common/certification/client.ts


var certificationGateway = function() {
    return {
        postTelCertification: new common_src/* PostCertificationGateway */.$T(axios/* axios */.o),
        getTelCertification: new common_src/* GetCertificationGateway */.xy(axios/* axios */.o)
    };
};

// EXTERNAL MODULE: ./src/styles/layout.ts
var layout = __webpack_require__(87336);
;// CONCATENATED MODULE: ./src/hooks/useTelCertification.tsx
function useTelCertification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useTelCertification_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useTelCertification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useTelCertification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var DEFAULT_TIME = 180;
var CERTIFY_LIMIT = 30;
var CERTIFICATION_UUID_KEY = "seq-certification-key";
var useTelCertification = function(param) {
    var defaultCount = param.defaultCount, _certifyLimit = param.certifyLimit, certifyLimit = _certifyLimit === void 0 ? CERTIFY_LIMIT : _certifyLimit, templateCode = param.templateCode;
    var getDefaultTime = (0,react.useCallback)(function() {
        var _defaultCount = defaultCount !== null && defaultCount !== void 0 ? defaultCount : DEFAULT_TIME;
        return {
            text: (0,utils/* formatTime */.mr)(_defaultCount),
            value: defaultCount || _defaultCount
        };
    }, [
        defaultCount
    ]);
    var ref = (0,design_system_pc/* useAlert */.VY)(), handleAlertOpen = ref.handleOpen;
    var ref1 = certificationGateway(), getTelCertification = ref1.getTelCertification, postTelCertification = ref1.postTelCertification;
    var ref2 = (0,react.useState)(function() {
        return getDefaultTime();
    }), count = ref2[0], setCount = ref2[1];
    var ref3 = (0,react.useState)("BEFORE_SEND"), status = ref3[0], setStatus = ref3[1];
    var throttleStatusRef = (0,react.useRef)({
        prevTel: null,
        countSnap: 0
    });
    var isThrottling = throttleStatusRef.current.countSnap - count.value <= 10;
    var handleSend = (0,react.useCallback)(function() {
        var _ref = useTelCertification_asyncToGenerator(runtime_default().mark(function _callee(tel) {
            var ref, uuid, response, defaultTime;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(throttleStatusRef.current.prevTel === tel && status === "CERTIFYING" && isThrottling)) {
                            _ctx.next = 6;
                            break;
                        }
                        handleAlertOpen({
                            content: "잠시 후에 다시 시도 해주세요.",
                            subContent: "동일한 연락처로 다시 전송하려면\n약 10초의 대기시간이 필요해요.",
                            zIndex: layout/* ALERT_Z_INDEX */.iO
                        });
                        return _ctx.abrupt("return");
                    case 6:
                        {
                            throttleStatusRef.current.prevTel = tel;
                            throttleStatusRef.current.countSnap = DEFAULT_TIME;
                        }
                    case 7:
                        uuid = window.sessionStorage.getItem(CERTIFICATION_UUID_KEY);
                        if (!(uuid === null)) {
                            _ctx.next = 11;
                            break;
                        }
                        console.error("[Error] UUID가 비어있습니다.");
                        return _ctx.abrupt("return");
                    case 11:
                        _ctx.next = 13;
                        return postTelCertification.exec({
                            tel: "".concat(tel),
                            templateCode: templateCode,
                            uuid: uuid
                        });
                    case 13:
                        response = _ctx.sent;
                        if (response.code === 200 && ((ref = response.data) === null || ref === void 0 ? void 0 : ref.cnt) && response.data.cnt > 0) {
                            if (response.data.cnt > certifyLimit) {
                                setStatus("EXCEEDED");
                            } else {
                                setStatus("CERTIFYING");
                                defaultTime = getDefaultTime();
                                setCount(defaultTime);
                            }
                        } else if (response.code === 11000) {
                            // 인증번호를 더 이상 전송 할 수 없습니다. 잠시 후 다시 시도 해주세요.
                            setStatus("EXCEEDED");
                        } else {
                            // 인증번호 신청 실패 시 케이스
                            console.error("[response: ".concat(response === null || response === void 0 ? void 0 : response.code, "]: ").concat(response === null || response === void 0 ? void 0 : response.message));
                        }
                        return _ctx.abrupt("return", response);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(tel) {
            return _ref.apply(this, arguments);
        };
    }(), [
        certifyLimit,
        getDefaultTime,
        handleAlertOpen,
        isThrottling,
        postTelCertification,
        status,
        templateCode, 
    ]);
    // eslint-disable-next-line no-unused-vars
    var handleCertification = (0,react.useCallback)(function() {
        var _ref = useTelCertification_asyncToGenerator(runtime_default().mark(function _callee(tel, certifiedNumber) {
            var _tel, certificationNoValue, uuid, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _tel = lodash_default().toString(tel);
                        certificationNoValue = lodash_default().toString(certifiedNumber);
                        uuid = window.sessionStorage.getItem(CERTIFICATION_UUID_KEY);
                        if (!(uuid === null)) {
                            _ctx.next = 6;
                            break;
                        }
                        console.error("[Error] UUID가 비어있습니다.");
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return getTelCertification.exec({
                            tel: _tel,
                            uuid: uuid,
                            certificationNoValue: certificationNoValue
                        });
                    case 8:
                        response = _ctx.sent;
                        if (response.code === 200) {
                            setStatus("CERTIFIED");
                        } else if (response.code === 11002) {
                            setStatus("TIME_EXPIRED");
                        } else if (response.code === 11001 || response.code === 12100) {
                            setStatus("INACCURATE");
                        } else {
                            console.error("[response: ".concat(response === null || response === void 0 ? void 0 : response.code, "]: ").concat(response === null || response === void 0 ? void 0 : response.message));
                        }
                        return _ctx.abrupt("return", response);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(tel, certifiedNumber) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getTelCertification
    ]);
    var handleResetStatus = (0,react.useCallback)(function(status) {
        setStatus(status || "BEFORE_SEND");
    }, []);
    /* 
    점유인증을 위한 UUID 는 sessionStorage 만료 기준
    따라서, 페이지 접근 시 최초 생성되며, 브라우저 종료 시 만료
    한샘몰 점유인증 위키: https://hanssem.atlassian.net/wiki/spaces/IT1/pages/1013973143
  */ (0,react.useEffect)(function() {
        if (true) {
            var hasUUID = window.sessionStorage.getItem(CERTIFICATION_UUID_KEY);
            if (hasUUID === null) {
                window.sessionStorage.setItem(CERTIFICATION_UUID_KEY, (0,v4/* default */.Z)());
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        var timer;
        if ((status === "CERTIFYING" || status === "INACCURATE") && count && count.value > 0) {
            timer = setInterval(function() {
                setCount(function(param) {
                    var text = param.text, value = param.value;
                    return value > 0 ? {
                        text: (0,utils/* formatTime */.mr)(value - 1),
                        value: value - 1
                    } : {
                        text: text,
                        value: value
                    };
                });
            }, 1000);
        } else if (count.value === 0) {
            clearInterval(timer);
            setStatus("TIME_EXPIRED");
            setCount(getDefaultTime());
        }
        return function() {
            return clearInterval(timer);
        };
    }, [
        count,
        getDefaultTime,
        status
    ]);
    return {
        handleSend: handleSend,
        handleCertification: handleCertification,
        handleResetStatus: handleResetStatus,
        count: count,
        status: status
    };
};
/* harmony default export */ var hooks_useTelCertification = (useTelCertification);

// EXTERNAL MODULE: ./src/types/seq-consult.ts
var types_seq_consult = __webpack_require__(30694);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/hooks/useSeqConsultQuestion.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function useSeqConsultQuestion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useSeqConsultQuestion_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useSeqConsultQuestion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useSeqConsultQuestion_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

















var TERMS = [
    {
        id: "privacy",
        text: "개인정보 수집 및 이용동의",
        popupTitle: "개인정보 수집 및 이용동의",
        popup: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonalInfoCollection/* default */.Z, {
            kind: "quick"
        })
    },
    {
        id: "provide",
        text: "개인정보 제3자 제공 동의",
        popupTitle: "개인정보 제3자 제공 동의",
        popup: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdParties/* default */.Z, {
            kind: "quick"
        })
    }, 
];
var useSeqConsultQuestion = function() {
    var ref, ref1, ref2;
    var ref3 = (0,index_esm/* useFormContext */.Gc)(), register = ref3.register, getValues = ref3.getValues, setValue = ref3.setValue, watch = ref3.watch, resetField = ref3.resetField, trigger = ref3.trigger, errors = ref3.formState.errors;
    var ref4 = useSeqConsultContext(), step = ref4.step, consultType = ref4.consultType, handleChangeTelCertificated = ref4.handleChangeTelCertificated;
    var handleOpen = (0,PopupProvider/* usePopup */.B)().handleOpen;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var getBasic = (0,client/* quickConsultGateway */.r)().getBasic;
    var ref5 = (0,dist/* default */.ZP)(isAuthenticated ? "seq-user-info" : null, function() {
        return getBasic.exec();
    }), userInfoResponse = ref5.data;
    var ref6 = (0,react.useState)(false), allScopeChecked = ref6[0], setAllScopeChecked = ref6[1];
    var currentConsultData = (0,react.useMemo)(function() {
        return consultType === "SEQ" ? seq_consult/* SEQ_CONSULT_DATA */.k_ : seq_consult/* MATCH_CONSULT_DATA */.FL;
    }, [
        consultType
    ]);
    var currentStepData = (0,react.useMemo)(function() {
        if (step in currentConsultData) {
            return currentConsultData[step];
        }
        return null;
    }, [
        currentConsultData,
        step
    ]);
    var user = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            name: userInfoResponse === null || userInfoResponse === void 0 ? void 0 : (ref = userInfoResponse.data) === null || ref === void 0 ? void 0 : ref.user.name,
            tel: userInfoResponse === null || userInfoResponse === void 0 ? void 0 : (ref1 = userInfoResponse.data) === null || ref1 === void 0 ? void 0 : ref1.user.tel
        };
    }, [
        userInfoResponse === null || userInfoResponse === void 0 ? void 0 : (ref = userInfoResponse.data) === null || ref === void 0 ? void 0 : ref.user.name,
        userInfoResponse === null || userInfoResponse === void 0 ? void 0 : (ref1 = userInfoResponse.data) === null || ref1 === void 0 ? void 0 : ref1.user.tel
    ]);
    var getActive = (0,react.useCallback)(function(value) {
        if (step === "baseConstructionPlan.scopes") {
            var ref;
            return (ref = watch("baseConstructionPlan.scopes")) === null || ref === void 0 ? void 0 : ref.includes(value);
        }
        return watch(step) === value;
    }, [
        step,
        watch
    ]);
    var handleClick = (0,react.useCallback)(function(value) {
        if (value === "ETC") {
            resetField("baseConstructionPlan.etcComment");
        }
        if (step === "baseConstructionPlan.scopes") {
            var prevValue = getValues(step) ? getValues(step) : [];
            if (prevValue.includes(value) && value) {
                setValue(step, prevValue.filter(function(_value) {
                    return _value !== value;
                }));
                if (value !== "ETC") {
                    setAllScopeChecked(false);
                }
            } else {
                var nextScopes = _toConsumableArray(prevValue).concat([
                    value
                ]);
                var isAllScopeWithoutETC = nextScopes.filter(function(scope) {
                    return scope !== "ETC";
                });
                setValue(step, nextScopes);
                if (isAllScopeWithoutETC.length === 11) {
                    setAllScopeChecked(true);
                }
            }
        }
        if (step !== "baseConstructionPlan.scopes") {
            if (getValues(step) === value) {
                setValue(step, undefined);
            } else {
                setValue(step, value);
            }
        }
        if ((currentStepData === null || currentStepData === void 0 ? void 0 : currentStepData.autoNext) && getActive(value)) {
            setTimeout(function() {
                var ref;
                var nextButtonEl = document.getElementById(seq_consult/* SEQ_CONSULT_NEXT_BUTTON_ID */.ZF);
                nextButtonEl === null || nextButtonEl === void 0 ? void 0 : (ref = nextButtonEl.click) === null || ref === void 0 ? void 0 : ref.call(nextButtonEl);
            }, 300);
        }
    }, [
        getValues,
        setValue,
        step,
        getActive,
        resetField,
        currentStepData
    ]);
    var isShowEtcInput = (ref2 = watch("baseConstructionPlan.scopes")) === null || ref2 === void 0 ? void 0 : ref2.includes("ETC");
    var handleChangeAllScopes = (0,react.useCallback)(function(e) {
        var ref;
        var isChecked = e.currentTarget.checked;
        setAllScopeChecked(isChecked);
        var hasEtc = (ref = getValues("baseConstructionPlan.scopes")) === null || ref === void 0 ? void 0 : ref.includes("ETC");
        if (isChecked) {
            var allScopes = seq_consult/* SPACE_SCOPES.data.filter */.gn.data.filter(function(item) {
                return item.value !== "ETC";
            }).map(function(item) {
                return item.value;
            });
            if (hasEtc) {
                allScopes.push("ETC");
            }
            setValue("baseConstructionPlan.scopes", allScopes);
        } else {
            if (hasEtc) {
                setValue("baseConstructionPlan.scopes", [
                    "ETC"
                ]);
            } else {
                setValue("baseConstructionPlan.scopes", []);
            }
        }
    }, [
        getValues,
        setValue
    ]);
    var ref7 = (0,react.useState)(false), allAgreementChecked = ref7[0], setIsAllAgreementChecked = ref7[1];
    var handleAllAgreement = (0,react.useCallback)(function(e) {
        var isChecked = e.currentTarget.checked;
        setIsAllAgreementChecked(isChecked);
        if (isChecked) {
            setValue("agreement.privacy", true);
            setValue("agreement.provide", true);
        } else {
            setValue("agreement.privacy", false);
            setValue("agreement.provide", false);
        }
    }, [
        setValue
    ]);
    var handleAgreementChecked = (0,react.useCallback)(function(e) {
        var targetName = e.currentTarget.name;
        var isChecked = e.currentTarget.checked;
        setValue(targetName, isChecked);
        if (getValues("agreement.privacy") && getValues("agreement.provide")) {
            setIsAllAgreementChecked(true);
        } else {
            setIsAllAgreementChecked(false);
        }
    }, [
        getValues,
        setValue
    ]);
    var handleAgreementPopup = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var targetName = e.currentTarget.name;
        var findTerm = TERMS.find(function(term) {
            return term.id === targetName;
        });
        if (findTerm) {
            handleOpen({
                popupProps: {
                    title: findTerm.popupTitle,
                    popupSize: "md",
                    buttonType: "noneBtn",
                    children: findTerm.popup
                }
            });
        }
    }, [
        handleOpen
    ]);
    var handleChangeTel = (0,react.useCallback)(function(e) {
        var value = e.currentTarget.value;
        var tel = value.replace(/[^0-9]/g, "").replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, ""); // eslint-disable-line
        setValue("tel", tel);
    }, [
        setValue
    ]);
    var handleChangeEtc = (0,react.useCallback)(function(e) {
        var value = e.currentTarget.value;
        if (value.length > 20) {
            value = value.slice(0, 20);
        }
        if (value.trim().length === 0) {
            setValue("baseConstructionPlan.etcComment", value.replace(/^\s*/, "").replace(/\s*$/, ""));
        } else {
            setValue("baseConstructionPlan.etcComment", value);
        }
    }, [
        setValue
    ]);
    var handleChangeName = function(e) {
        var value = e.currentTarget.value;
        if (value.length > 20) {
            value = value.slice(0, 20);
        }
        if (value.trim().length === 0) {
            setValue("name", value.replace(/^\s*/, "").replace(/\s*$/, ""));
        } else {
            setValue("name", value);
        }
    };
    var ref8 = hooks_useTelCertification({
        templateCode: types_seq_consult/* SEQ_CONSULT_KAKAO_TEMPLATE_CODE */.O
    }), handleSend = ref8.handleSend, handleCertification = ref8.handleCertification, handleResetStatus = ref8.handleResetStatus, count = ref8.count, status = ref8.status;
    var ref9 = (0,react.useState)(""), certificationNumber = ref9[0], setCertificationNumber = ref9[1];
    var ref10 = (0,react.useState)(false), isTelDisabled = ref10[0], setIsTelDisabled = ref10[1];
    var handleChangeCertificationNumber = (0,react.useCallback)(function(e) {
        if (e.target.value.length > 6) {
            return;
        }
        setCertificationNumber(e.target.value);
    }, []);
    var toast = (0,design_system_pc/* useToast */.pm)().toast;
    var handleSendTel = (0,react.useCallback)(useSeqConsultQuestion_asyncToGenerator(runtime_default().mark(function _callee() {
        var isPassed, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return trigger("tel");
                case 2:
                    isPassed = _ctx.sent;
                    if (!isPassed) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 6;
                    return handleSend(getValues("tel"));
                case 6:
                    response = _ctx.sent;
                    if ((response === null || response === void 0 ? void 0 : response.code) === 200) {
                        toast.success("인증번호가 전송 되었습니다.", {
                            alignment: "center",
                            placement: "bottom",
                            variant: "basic",
                            offset: 40,
                            zIndex: styles/* TOAST_Z_INDEX */.kb,
                            duration: 3
                        });
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        getValues,
        handleSend,
        toast,
        trigger
    ]);
    var handleSendCertificationNumber = (0,react.useCallback)(useSeqConsultQuestion_asyncToGenerator(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsTelDisabled(false);
                    _ctx.next = 3;
                    return handleCertification(getValues("tel"), certificationNumber);
                case 3:
                    response = _ctx.sent;
                    if ((response === null || response === void 0 ? void 0 : response.code) === 200) {
                        toast.success("인증이 완료 되었습니다.", {
                            alignment: "center",
                            placement: "bottom",
                            variant: "basic",
                            offset: 40,
                            zIndex: styles/* TOAST_Z_INDEX */.kb,
                            duration: 3
                        });
                        setIsTelDisabled(true);
                        handleChangeTelCertificated(true);
                        setCertificationNumber("");
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        certificationNumber,
        getValues,
        handleCertification,
        handleChangeTelCertificated,
        toast, 
    ]);
    var handleEnableTelInput = (0,react.useCallback)(function() {
        handleResetStatus();
        setValue("tel", "");
        setIsTelDisabled(false);
        handleChangeTelCertificated(false);
    }, [
        handleChangeTelCertificated,
        handleResetStatus,
        setValue
    ]);
    var ref11 = hooks_useSeqConsult(), workAvailableAreas = ref11.workAvailableAreas, isOpenWorkableBottomSheet = ref11.isOpenWorkableBottomSheet, handleOpenBottomSheet = ref11.handleOpenBottomSheet, handleCloseBottomSheet = ref11.handleCloseBottomSheet;
    return {
        handleClick: handleClick,
        register: register,
        watch: watch,
        step: step,
        isShowEtcInput: isShowEtcInput,
        allFlagChecked: allScopeChecked,
        handleChangeAllScopes: handleChangeAllScopes,
        getActive: getActive,
        errors: errors,
        handleAllAgreement: handleAllAgreement,
        allAgreementChecked: allAgreementChecked,
        handleAgreementChecked: handleAgreementChecked,
        handleAgreementPopup: handleAgreementPopup,
        handleChangeTel: handleChangeTel,
        isAuthenticated: isAuthenticated,
        user: user,
        handleChangeEtc: handleChangeEtc,
        handleChangeName: handleChangeName,
        certificationNumber: certificationNumber,
        handleChangeCertificationNumber: handleChangeCertificationNumber,
        handleSendTel: handleSendTel,
        count: count,
        status: status,
        isTelDisabled: isTelDisabled,
        handleSendCertificationNumber: handleSendCertificationNumber,
        handleEnableTelInput: handleEnableTelInput,
        workAvailableAreas: workAvailableAreas,
        isOpenWorkableBottomSheet: isOpenWorkableBottomSheet,
        handleOpenBottomSheet: handleOpenBottomSheet,
        handleCloseBottomSheet: handleCloseBottomSheet,
        currentStepData: currentStepData,
        consultType: consultType
    };
};
/* harmony default export */ var hooks_useSeqConsultQuestion = (useSeqConsultQuestion);

// EXTERNAL MODULE: ./src/ui/SearchAddress/index.ts + 8 modules
var SearchAddress = __webpack_require__(93478);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/hooks/useSeqSearchAddressForm.tsx
function useSeqSearchAddressForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useSeqSearchAddressForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useSeqSearchAddressForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useSeqSearchAddressForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useSeqSearchAddressForm_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useSeqSearchAddressForm_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var useSeqSearchAddressForm = function() {
    var ref, ref1;
    var ref2 = (0,index_esm/* useFormContext */.Gc)(), register = ref2.register, setValue = ref2.setValue, watch = ref2.watch, errors = ref2.formState.errors, control = ref2.control;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var ref3 = (0,PopupProvider/* usePopup */.B)(), searchAddressPopupOpen = ref3.handleOpen, searchAddressPopupClose = ref3.handleClose;
    var ref4 = useSeqConsultContext(), userBasicInfo = ref4.userBasicInfo, defaultRadio = ref4.defaultRadio, handleChangeIsDefaultAddress = ref4.handleChangeIsDefaultAddress;
    var ref5 = (0,react.useState)(defaultRadio), radioType = ref5[0], setRadioType = ref5[1];
    var isShowRadioGroup = (0,react.useMemo)(function() {
        return !!userBasicInfo && userBasicInfo.simpleUserFlag === "N";
    }, [
        userBasicInfo
    ]);
    var _handleSearchAddress = (0,react.useCallback)(function(address) {
        var _address = {
            address: {
                sidoCode: address.lglSidoCd,
                houseCode: address.houseCd,
                sidoName: address.sidoNm,
                sigunguCode: address.lglSiguCd,
                sigunguName: address.siguNm,
                zoneCode: address.post5No,
                dongCode: address.lglDngCd,
                dongName: address.dngNm,
                roadnameCode: address.roadCd,
                roadnameAddress: address.addrRoad,
                buildingCode: address.bldgMgmtNo,
                buildingName: address.bldgNm,
                x: parseFloat(address.wgs84XBldgAvg),
                y: parseFloat(address.wgs84YBldgAvg)
            },
            addressDetail: ""
        };
        setValue("site.address", useSeqSearchAddressForm_objectSpreadProps(useSeqSearchAddressForm_objectSpread({}, _address.address), {
            addressDetail: _address.addressDetail
        }));
        searchAddressPopupClose();
    }, [
        searchAddressPopupClose,
        setValue
    ]);
    var handleOpenSearchAddressPopup = function(e) {
        e.preventDefault();
        searchAddressPopupOpen({
            popupProps: {
                popupSize: "md",
                title: "우편번호 검색",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddress/* default */.Z, {
                    handleSearchAddress: _handleSearchAddress
                })
            }
        });
    };
    var handleChangeRadio = (0,react.useCallback)(function(e) {
        var type = e.currentTarget.name;
        setRadioType(type);
        handleChangeIsDefaultAddress(type);
        if (type === "default") {
            var ref, ref1;
            setValue("site.address", userBasicInfo === null || userBasicInfo === void 0 ? void 0 : (ref = userBasicInfo.site) === null || ref === void 0 ? void 0 : ref.address);
            setValue("site.addressDetail", userBasicInfo === null || userBasicInfo === void 0 ? void 0 : (ref1 = userBasicInfo.site) === null || ref1 === void 0 ? void 0 : ref1.addressDetail);
        } else {
            setValue("site.address", {
                sidoCode: "",
                houseCode: "",
                sidoName: "",
                sigunguCode: "",
                sigunguName: "",
                zoneCode: "",
                dongCode: "",
                dongName: "",
                roadnameCode: "",
                roadnameAddress: "",
                buildingCode: "",
                buildingName: "",
                x: "",
                y: ""
            });
            setValue("site.addressDetail", "");
        }
    }, [
        handleChangeIsDefaultAddress,
        setValue,
        userBasicInfo === null || userBasicInfo === void 0 ? void 0 : (ref = userBasicInfo.site) === null || ref === void 0 ? void 0 : ref.address,
        userBasicInfo === null || userBasicInfo === void 0 ? void 0 : (ref1 = userBasicInfo.site) === null || ref1 === void 0 ? void 0 : ref1.addressDetail, 
    ]);
    var handleChangeDetailAddress = (0,react.useCallback)(function(e) {
        var value = e.currentTarget.value;
        if (value.length > 50) {
            value = value.slice(0, 50);
        }
        if (value.trim().length === 0) {
            setValue("site.addressDetail", value.replace(/^\s*/, "").replace(/\s*$/, ""));
        } else setValue("site.addressDetail", value);
    }, [
        setValue
    ]);
    var watchZoneCode = (0,index_esm/* useWatch */.qo)({
        name: "site.address.zoneCode",
        control: control
    });
    var watchRoadNameAddress = (0,index_esm/* useWatch */.qo)({
        name: "site.address.roadnameAddress",
        control: control
    });
    var watchAddressDetail = (0,index_esm/* useWatch */.qo)({
        name: "site.addressDetail",
        control: control
    });
    var disabledZoneCode = (0,react.useMemo)(function() {
        return !!watchZoneCode;
    }, [
        watchZoneCode
    ]);
    var disabledRoadNameAddress = (0,react.useMemo)(function() {
        return !disabledZoneCode || !!disabledZoneCode && !!watchRoadNameAddress;
    }, [
        disabledZoneCode,
        watchRoadNameAddress
    ]);
    var disabledAddressDetail = (0,react.useMemo)(function() {
        if (radioType === "default") {
            return !!watchZoneCode && !!watchAddressDetail && isShowRadioGroup || !watchZoneCode && !watchAddressDetail;
        } else {
            return !watchZoneCode && !watchAddressDetail;
        }
    }, [
        isShowRadioGroup,
        radioType,
        watchAddressDetail,
        watchZoneCode
    ]);
    var disabledSearchButton = (0,react.useMemo)(function() {
        return isShowRadioGroup && radioType === "default";
    }, [
        isShowRadioGroup,
        radioType
    ]);
    return {
        isAuthenticated: isAuthenticated,
        handleOpenSearchAddressPopup: handleOpenSearchAddressPopup,
        radioType: radioType,
        handleChangeRadio: handleChangeRadio,
        register: register,
        watch: watch,
        errors: errors,
        disabledZoneCode: disabledZoneCode,
        disabledRoadNameAddress: disabledRoadNameAddress,
        disabledAddressDetail: disabledAddressDetail,
        disabledSearchButton: disabledSearchButton,
        isShowRadioGroup: isShowRadioGroup,
        handleChangeDetailAddress: handleChangeDetailAddress
    };
};
/* harmony default export */ var hooks_useSeqSearchAddressForm = (useSeqSearchAddressForm);

;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/SeqSearchAddressForm.tsx
function SeqSearchAddressForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqSearchAddressForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqSearchAddressForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SeqSearchAddressForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SeqSearchAddressForm_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SeqSearchAddressForm_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var SeqSearchAddressForm = function() {
    var ref = hooks_useSeqSearchAddressForm(), handleOpenSearchAddressPopup = ref.handleOpenSearchAddressPopup, radioType = ref.radioType, handleChangeRadio = ref.handleChangeRadio, handleChangeDetailAddress = ref.handleChangeDetailAddress, register = ref.register, errors = ref.errors, disabledZoneCode = ref.disabledZoneCode, disabledAddressDetail = ref.disabledAddressDetail, disabledRoadNameAddress = ref.disabledRoadNameAddress, disabledSearchButton = ref.disabledSearchButton, isShowRadioGroup = ref.isShowRadioGroup;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
        children: [
            isShowRadioGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                space: 24,
                height: "40px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* RadioButton */.EU, {
                        name: "default",
                        mr: "24px",
                        labelOptions: {
                            text: "기본배송지",
                            textVariant: "body1"
                        },
                        checked: radioType === "default",
                        onChange: handleChangeRadio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* RadioButton */.EU, {
                        name: "direct",
                        labelOptions: {
                            text: "직접입력",
                            textVariant: "body1"
                        },
                        checked: radioType === "direct",
                        onChange: handleChangeRadio
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                space: 8,
                mb: "4px",
                py: "4px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqSearchAddressForm_objectSpread({
                        size: "lg",
                        placeholder: "우편번호",
                        flex: 1,
                        disabled: disabledZoneCode,
                        readOnly: true
                    }, register("site.address.zoneCode"))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, {
                        type: "button",
                        width: 143,
                        style: {
                            borderRadius: "0"
                        },
                        icon: {
                            variant: "ic_search",
                            align: "left"
                        },
                        emphasis: "low",
                        size: "lg",
                        disabled: disabledSearchButton,
                        onClick: handleOpenSearchAddressPopup,
                        children: "우편번호 검색"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                mb: "4px",
                py: "4px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqSearchAddressForm_objectSpreadProps(SeqSearchAddressForm_objectSpread({
                    size: "lg",
                    placeholder: "주소 입력",
                    flex: 1
                }, register("site.address.roadnameAddress")), {
                    disabled: disabledRoadNameAddress
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                py: "4px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqSearchAddressForm_objectSpreadProps(SeqSearchAddressForm_objectSpread({
                    size: "lg",
                    placeholder: "상세 주소",
                    flex: 1
                }, register("site.addressDetail", {
                    required: {
                        value: true,
                        message: ""
                    },
                    pattern: {
                        value: /^[^ㄱ-ㅎㅏ-ㅣ]{1,50}$/g,
                        message: "주소를 정확히 입력해 주세요."
                    },
                    onChange: handleChangeDetailAddress
                })), {
                    disabled: disabledAddressDetail,
                    isError: (0,utils/* hasFieldError */.yu)(errors, "site.addressDetail"),
                    errorMessage: "주소를 정확히 입력해 주세요."
                }))
            })
        ]
    });
};
SeqSearchAddressForm.displayName = "SeqSearchAddressForm";
/* harmony default export */ var SeqConsult_SeqSearchAddressForm = (SeqSearchAddressForm);

;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/SeqConsultQuestion.tsx
function SeqConsultQuestion_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqConsultQuestion_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqConsultQuestion_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SeqConsultQuestion_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SeqConsultQuestion_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SeqConsultQuestion_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SeqConsultQuestion_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SeqConsultQuestion_templateObject() {
    var data = SeqConsultQuestion_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    SeqConsultQuestion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SeqConsultQuestion_templateObject1() {
    var data = SeqConsultQuestion_taggedTemplateLiteral([
        "\n  width: 420px;\n  height: auto;\n"
    ]);
    SeqConsultQuestion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SeqConsultQuestion_templateObject2() {
    var data = SeqConsultQuestion_taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n  gap: 12px 25px;\n"
    ]);
    SeqConsultQuestion_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var SeqConsultQuestion = function(props) {
    var ref = useSeqConsultContext(), workAvailableAreas = ref.workAvailableAreas, isOpenWorkableBottomSheet = ref.isOpenWorkableBottomSheet, handleOpenBottomSheet = ref.handleOpenBottomSheet, handleCloseBottomSheet = ref.handleCloseBottomSheet;
    var ref1 = hooks_useSeqConsultQuestion(), step = ref1.step, watch = ref1.watch, errors = ref1.errors, register = ref1.register, handleClick = ref1.handleClick, isShowEtcInput = ref1.isShowEtcInput, // allFlagChecked,
    // handleChangeAllScopes,
    getActive = ref1.getActive, handleAllAgreement = ref1.handleAllAgreement, allAgreementChecked = ref1.allAgreementChecked, handleAgreementChecked = ref1.handleAgreementChecked, handleAgreementPopup = ref1.handleAgreementPopup, handleChangeTel = ref1.handleChangeTel, user = ref1.user, handleChangeEtc = ref1.handleChangeEtc, handleChangeName = ref1.handleChangeName, certificationNumber = ref1.certificationNumber, handleChangeCertificationNumber = ref1.handleChangeCertificationNumber, handleSendTel = ref1.handleSendTel, count = ref1.count, status = ref1.status, handleSendCertificationNumber = ref1.handleSendCertificationNumber, isTelDisabled = ref1.isTelDisabled, handleEnableTelInput = ref1.handleEnableTelInput, currentStepData = ref1.currentStepData;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var renderRightPart = (0,react.useCallback)(function(status) {
        if (isAuthenticated) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
        if (status === "CERTIFIED") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, {
                type: "button",
                emphasis: "low",
                size: "lg",
                width: "119px",
                onClick: handleEnableTelInput,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                    variant: "label_lg_r",
                    children: "변경"
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, {
            type: "button",
            emphasis: "low",
            size: "lg",
            onClick: handleSendTel,
            minWidth: "119px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                variant: "label_lg_r",
                children: status === "BEFORE_SEND" ? "인증번호 전송" : "재전송"
            })
        });
    }, [
        handleEnableTelInput,
        handleSendTel,
        isAuthenticated
    ]);
    if (!currentStepData && step !== "personal") {
        return null;
    }
    var renderAnswerBasicGrid = function(data) {
        var colSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            colSize: colSize,
            colGap: 20,
            rowGap: 20,
            children: data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultOptionButton, {
                    isActive: getActive(item.value),
                    onClick: function() {
                        return handleClick(item.value);
                    },
                    children: item.name
                }, "seq-question-button-".concat(item.value));
            })
        });
    };
    if (step === "baseConstructionPlan.age" || step === "site.buildingType" || step === "site.houseNMPG" || step === "baseConstructionPlan.spaceStatus" || step === "baseConstructionPlan.consultPurpose" || step === "baseConstructionPlan.consultExperience" || step === "baseConstructionPlan.opinionReflect") {
        return renderAnswerBasicGrid((currentStepData === null || currentStepData === void 0 ? void 0 : currentStepData.data) || []);
    }
    if (step === "baseConstructionPlan.communicationStyle" || step === "baseConstructionPlan.budgetOption") {
        return renderAnswerBasicGrid((currentStepData === null || currentStepData === void 0 ? void 0 : currentStepData.data) || [], 1);
    }
    if (step === "baseConstructionPlan.scopes") {
        var ref2;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    colSize: 3,
                    colGap: 20,
                    rowGap: 24,
                    children: currentStepData === null || currentStepData === void 0 ? void 0 : (ref2 = currentStepData.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultOptionButton, {
                            variant: "photo",
                            isActive: getActive(item.value),
                            onClick: function() {
                                return handleClick(item.value);
                            },
                            imgSrc: "/assets/images/seq-consult/scope/".concat(String(item.value).toLowerCase(), ".jpg"),
                            children: item.name
                        }, "seq-question-button-".concat(item.value));
                    })
                }),
                isShowEtcInput && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    mt: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                            offset: {
                                right: -4,
                                top: 0
                            },
                            size: "sm",
                            zIndex: 50,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                variant: "subTitle6",
                                mb: "12px",
                                children: "기타 내용을 입력해주세요 (20자 이내)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqConsultQuestion_objectSpreadProps(SeqConsultQuestion_objectSpread({
                            size: "lg"
                        }, register("baseConstructionPlan.etcComment", {
                            required: isShowEtcInput,
                            pattern: {
                                value: /^[^ㄱ-ㅎㅏ-ㅣ]{1,20}$/g,
                                message: "내용을 정확히 입력해주세요."
                            },
                            onChange: function(e) {
                                return handleChangeEtc(e);
                            }
                        })), {
                            placeholder: "ex) 주방수전교체, 시스템에어컨",
                            maxLength: 20,
                            isError: (0,utils/* hasFieldError */.yu)(errors, "baseConstructionPlan.etcComment"),
                            errorMessage: (0,utils/* getFieldErrorMessage */.wJ)(errors, "baseConstructionPlan.etcComment"),
                            onKeyDown: function(e) {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                }
                            }
                        }))
                    ]
                })
            ]
        });
    }
    if (step === "baseConstructionPlan.budget") {
        var ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            colSize: 2,
            colGap: 20,
            rowGap: 20,
            children: currentStepData === null || currentStepData === void 0 ? void 0 : (ref3 = currentStepData.data) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultOptionButton, {
                    isActive: getActive(item.value),
                    onClick: function() {
                        return handleClick(item.value);
                    },
                    children: item.name
                }, "seq-question-button-".concat(item.value));
            })
        });
    }
    if (step === "baseConstructionPlan.consultSchedule") {
        var ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
            colSize: 2,
            colGap: 20,
            rowGap: 20,
            children: currentStepData === null || currentStepData === void 0 ? void 0 : (ref4 = currentStepData.data) === null || ref4 === void 0 ? void 0 : ref4.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultOptionButton, {
                    isActive: getActive(item.value),
                    onClick: function() {
                        return handleClick(item.value);
                    },
                    children: item.name
                }, "seq-question-button-".concat(item.value));
            })
        });
    }
    if (step === "baseConstructionPlan.desiredDay") {
        var ref5;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    colSize: 2,
                    colGap: 20,
                    rowGap: 20,
                    children: currentStepData === null || currentStepData === void 0 ? void 0 : (ref5 = currentStepData.data) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultOptionButton, {
                            isActive: getActive(item.value),
                            onClick: function() {
                                return handleClick(item.value);
                            },
                            children: item.name
                        }, "seq-question-button-".concat(item.value));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodStepNotice, {
                    mt: "48px",
                    pt: "16px",
                    pb: "16px",
                    borderTop: "1px solid",
                    borderColor: "color_chip.gray.200",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                        as: "ul",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "body2",
                                    color: "color_chip.gray.800",
                                    children: "주문량이 몰리는 경우 시공일이 다소 지연될 수 있습니다."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                as: "li",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "body2",
                                    color: "color_chip.gray.800",
                                    children: "담당 디자이너를 통해 최선의 일정으로 진행될 수 있도록 하겠습니다."
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    // if (step === 'site.address') {
    //   return <SeqSearchAddressForm />;
    // }
    if (step === "personal") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    mb: "12px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                        offset: {
                            right: -4,
                            top: 0
                        },
                        size: "sm",
                        zIndex: 50,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle5",
                            children: "이름"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    mb: "52px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqConsultQuestion_objectSpread({
                        type: "text",
                        size: "lg",
                        placeholder: "이름 입력",
                        disabled: !!user.name,
                        value: user.name || watch("name"),
                        isError: (0,utils/* hasFieldError */.yu)(errors, "name"),
                        errorMessage: (0,utils/* getFieldErrorMessage */.wJ)(errors, "name"),
                        maxLength: 20
                    }, register("name", {
                        required: {
                            value: true,
                            message: "이름을 정확히 입력해 주세요."
                        },
                        pattern: {
                            value: new RegExp(seq_consult/* CONSULT_NAME_PATTERN */.QB),
                            message: "이름을 정확히 입력해 주세요."
                        },
                        onChange: handleChangeName
                    })))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    mb: "12px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                        offset: {
                            right: -4,
                            top: 0
                        },
                        size: "sm",
                        zIndex: 50,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "subTitle5",
                            children: "휴대폰번호"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    mb: "52px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                            space: 8,
                            mb: "8px",
                            style: {
                                alignItems: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, SeqConsultQuestion_objectSpreadProps(SeqConsultQuestion_objectSpread({
                                    flex: "1",
                                    type: "text",
                                    size: "lg",
                                    disabled: !!user.tel || isTelDisabled,
                                    value: user.tel || watch("tel"),
                                    placeholder: "숫자만 입력",
                                    maxLength: 13
                                }, register("tel", {
                                    required: {
                                        value: true,
                                        message: "휴대폰번호를 정확히 입력해 주세요."
                                    },
                                    pattern: {
                                        value: /^\d{3}-\d{3,4}-\d{4}$/,
                                        message: "휴대폰번호를 정확히 입력해 주세요."
                                    },
                                    onChange: handleChangeTel
                                })), {
                                    isError: status === "EXCEEDED" || status === "TIME_EXPIRED" || (0,utils/* hasFieldError */.yu)(errors, "tel"),
                                    errorMessage: seq_consult/* CERTIFY_ERROR_MESSAGE */.iK[status] || (0,utils/* getFieldErrorMessage */.wJ)(errors, "tel")
                                })),
                                renderRightPart(status)
                            ]
                        }),
                        (status === "CERTIFYING" || status === "INACCURATE") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                            space: 8,
                            style: {
                                alignItems: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Input */.II, {
                                    autoFocus: true,
                                    type: "number",
                                    size: "lg",
                                    flex: 1,
                                    maxLength: 6,
                                    placeholder: "인증번호 입력",
                                    value: certificationNumber,
                                    onChange: handleChangeCertificationNumber,
                                    isError: status === "INACCURATE",
                                    errorMessage: seq_consult/* CERTIFY_ERROR_MESSAGE.INACCURATE */.iK.INACCURATE,
                                    rightPart: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 4,
                                        width: "115px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                color: "color_chip.primary",
                                                resize: true,
                                                size: 16,
                                                useFillColor: true,
                                                variant: "ic_time"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                                color: "color_chip.primary",
                                                variant: "body2",
                                                children: [
                                                    "남은 시간 ",
                                                    count.text
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, {
                                    type: "button",
                                    emphasis: "low",
                                    size: "lg",
                                    width: "119px",
                                    onClick: handleSendCertificationNumber,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        variant: "label_lg_r",
                                        children: "확인"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    mb: "52px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* DotBadge */.kU, {
                                    offset: {
                                        right: -4,
                                        top: 0
                                    },
                                    size: "sm",
                                    zIndex: 50,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        variant: "subTitle5",
                                        children: "시공 주소"
                                    })
                                }),
                                workAvailableAreas && /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: 4,
                                    mt: "4px",
                                    mb: "12px",
                                    alignment: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewTextButton */.rT, {
                                            icon: {
                                                align: "right",
                                                variant: "ic_alert"
                                            },
                                            color: "color_chip.blue.500",
                                            size: "md",
                                            onClick: handleOpenBottomSheet,
                                            type: "button",
                                            id: "workableAreaButton",
                                            position: "relative",
                                            children: "상담 가능 지역"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "body2",
                                            color: "color_chip.gray.800",
                                            children: "외 신청시 담당자가 변경될 수 있습니다"
                                        })
                                    ]
                                }),
                                !workAvailableAreas && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HelperText */.p6, {
                                    variant: "caption1",
                                    isShow: true,
                                    mt: "4px",
                                    mb: "12px",
                                    children: "인테리어가 필요한 지역의 전문가를 연결해 드릴 예정입니다."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqSearchAddressForm, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    mb: "12px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                        variant: "subTitle5",
                        children: "요청사항 (선택)"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    mb: "62px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Textarea */.gx, SeqConsultQuestion_objectSpread({
                        fixedHeight: "84px",
                        maxLength: 300,
                        placeholder: "ex) 5인가족이라 짐이 많아요. 수납공간을 넉넉하게 배치하고 싶어요."
                    }, register("comment")))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                            mb: "12px",
                            height: "48px",
                            borderBottom: "1px solid",
                            borderColor: "color_chip.primary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* CheckBox */.Jg, {
                                    "data-cypress-element": "all-checkbox",
                                    id: "seq-all-checkbox",
                                    checked: allAgreementChecked,
                                    onChange: handleAllAgreement
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "seq-all-checkbox",
                                    style: {
                                        marginLeft: "6px",
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        as: "span",
                                        variant: "headline6",
                                        children: "개인정보 수집 동의"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: "space-between",
                                    width: "100%",
                                    height: "48px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* CheckBox */.Jg, SeqConsultQuestion_objectSpreadProps(SeqConsultQuestion_objectSpread({
                                                    labelOptions: {
                                                        text: "개인정보 수집 및 이용동의",
                                                        textVariant: "body2"
                                                    }
                                                }, register("agreement.privacy")), {
                                                    checked: watch("agreement.privacy"),
                                                    onChange: handleAgreementChecked
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body2",
                                                    color: "color_chip.red.400",
                                                    ml: "4px",
                                                    children: "(필수)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, {
                                            type: "button",
                                            name: "privacy",
                                            emphasis: "low",
                                            size: "sm",
                                            width: "72px",
                                            style: {
                                                borderRadius: "2px"
                                            },
                                            onClick: handleAgreementPopup,
                                            children: "보기"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: "space-between",
                                    width: "100%",
                                    height: "48px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* CheckBox */.Jg, SeqConsultQuestion_objectSpreadProps(SeqConsultQuestion_objectSpread({
                                                    labelOptions: {
                                                        text: "개인정보 제3자 제공 동의",
                                                        textVariant: "body2"
                                                    }
                                                }, register("agreement.provide")), {
                                                    checked: watch("agreement.provide"),
                                                    onChange: handleAgreementChecked
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body2",
                                                    color: "color_chip.red.400",
                                                    ml: "4px",
                                                    children: "(필수)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, {
                                            type: "button",
                                            name: "provide",
                                            emphasis: "low",
                                            size: "sm",
                                            width: "72px",
                                            style: {
                                                borderRadius: "2px"
                                            },
                                            onClick: handleAgreementPopup,
                                            children: "보기"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinePopup, {
                    isOpen: isOpenWorkableBottomSheet,
                    portalId: "workableAreaButton",
                    position: "absolute",
                    top: "28px",
                    left: "0",
                    margin: "0",
                    isControlBGScroll: true,
                    isControlBGPointerEvent: true,
                    handleClose: handleCloseBottomSheet,
                    zIndex: styles/* HEADER_Z_INDEX */.bf - 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                        overflow: "hidden",
                        py: 12,
                        width: 362,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheetHStack, {
                            children: workAvailableAreas === null || workAvailableAreas === void 0 ? void 0 : workAvailableAreas.slice(0, 20).map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                            width: "1px",
                                            height: 12,
                                            backgroundColor: "color_chip.gray.200",
                                            position: "absolute",
                                            top: "2px",
                                            left: "-13px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "label_lg_r",
                                            color: "color_chip.primary",
                                            children: item
                                        })
                                    ]
                                }, "work-available-areas-".concat(item));
                            })
                        })
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var SeqConsult_SeqConsultQuestion = (SeqConsultQuestion);
var PeriodStepNotice = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "SeqConsultQuestion__PeriodStepNotice",
    componentId: "sc-95086e32-0"
})(SeqConsultQuestion_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    li {\n      position: relative;\n      margin-bottom: 4px;\n      padding-left: 12px;\n\n      &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        width: 4px;\n        height: 4px;\n        top: 7px;\n        left: 0;\n        background-color: ".concat(theme.colors.color_chip.gray["500"], ";\n        border-radius: 50%;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  ");
});
var StyledLinePopup = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* LinePopup */.qg).withConfig({
    displayName: "SeqConsultQuestion__StyledLinePopup",
    componentId: "sc-95086e32-1"
})(SeqConsultQuestion_templateObject1());
var BottomSheetHStack = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* HStack */.zn).withConfig({
    displayName: "SeqConsultQuestion__BottomSheetHStack",
    componentId: "sc-95086e32-2"
})(SeqConsultQuestion_templateObject2());

;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/hooks/useSeqConsultControls.tsx





var useSeqConsultControls = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), watch = ref.watch, control = ref.control;
    var isAuthenticated = (0,useAuthenticated/* default */.Z)().isAuthenticated;
    var ref1 = useSeqConsultContext(), step = ref1.step, handleNext = ref1.handleNext, handlePrev = ref1.handlePrev, handleSubmit = ref1.handleSubmit, isTelCertificated = ref1.isTelCertificated, consultType = ref1.consultType;
    var watchName = (0,index_esm/* useWatch */.qo)({
        name: "name",
        control: control
    });
    var watchTel = (0,index_esm/* useWatch */.qo)({
        name: "tel",
        control: control
    });
    var watchAgreementPrivacy = (0,index_esm/* useWatch */.qo)({
        name: "agreement.privacy",
        control: control
    });
    var watchAgreementProvide = (0,index_esm/* useWatch */.qo)({
        name: "agreement.provide",
        control: control
    });
    var isFirstStep = (0,react.useMemo)(function() {
        if (consultType === "MATCH") {
            return step === "baseConstructionPlan.age";
        }
        return step === "site.buildingType";
    }, [
        step,
        consultType
    ]);
    var disabledNextStep = (0,react.useCallback)(function() {
        if (step === "baseConstructionPlan.scopes") {
            var scopeValues = watch(step);
            var hasEtc = scopeValues === null || scopeValues === void 0 ? void 0 : scopeValues.includes("ETC");
            if (hasEtc) {
                var ref;
                var etcCommentLength = (ref = watch("baseConstructionPlan.etcComment")) === null || ref === void 0 ? void 0 : ref.length;
                return !etcCommentLength || etcCommentLength > 20 || !(scopeValues === null || scopeValues === void 0 ? void 0 : scopeValues.length);
            } else {
                return !(scopeValues === null || scopeValues === void 0 ? void 0 : scopeValues.length);
            }
        }
        if (step === "personal") {
            var site = watch("site");
            var base = watchName && watchTel && watchAgreementPrivacy && watchAgreementProvide && (site === null || site === void 0 ? void 0 : site.address) && (site === null || site === void 0 ? void 0 : site.addressDetail);
            var isPassedPersonalStep = isAuthenticated ? base : base && isTelCertificated;
            return !isPassedPersonalStep;
        }
        // 값이 0인 경우에도 다음 버튼이 활성화 될 수 있도록 예외처리
        if (watch(step) === 0) {
            return false;
        }
        return !watch(step);
    }, [
        isAuthenticated,
        isTelCertificated,
        step,
        watch,
        watchAgreementPrivacy,
        watchAgreementProvide,
        watchName,
        watchTel, 
    ]);
    var isLastStep = (0,react.useMemo)(function() {
        return step === "personal";
    }, [
        step
    ]);
    var getGtmKey = (0,react.useCallback)(function(step) {
        var ref;
        var currentConsultData = seq_consult/* CONSULT_TYPE_DATA */.LU[consultType];
        return (ref = currentConsultData[step]) === null || ref === void 0 ? void 0 : ref.gtmKey;
    }, [
        consultType
    ]);
    var prevButtonGtmKey = (0,react.useMemo)(function() {
        var gtmKey = getGtmKey(step);
        return gtmKey ? "seq_".concat(gtmKey, "_prev_consult") : "";
    }, [
        step,
        getGtmKey
    ]);
    var nextButtonGtmKey = (0,react.useMemo)(function() {
        var gtmKey = getGtmKey(step);
        return gtmKey ? "seq_".concat(gtmKey, "_next_consult") : "";
    }, [
        step,
        getGtmKey
    ]);
    return {
        isFirstStep: isFirstStep,
        handlePrev: handlePrev,
        handleNext: handleNext,
        disabledNextStep: disabledNextStep,
        isLastStep: isLastStep,
        handleSubmit: handleSubmit,
        prevButtonGtmKey: prevButtonGtmKey,
        nextButtonGtmKey: nextButtonGtmKey
    };
};
/* harmony default export */ var hooks_useSeqConsultControls = (useSeqConsultControls);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/SeqConsultControls.tsx
function SeqConsultControls_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqConsultControls_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqConsultControls_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SeqConsultControls_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SeqConsultControls_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SeqConsultControls_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SeqConsultControls = function() {
    var ref = hooks_useSeqConsultControls(), isFirstStep = ref.isFirstStep, disabledNextStep = ref.disabledNextStep, handleNext = ref.handleNext, handlePrev = ref.handlePrev, isLastStep = ref.isLastStep, prevButtonGtmKey = ref.prevButtonGtmKey, nextButtonGtmKey = ref.nextButtonGtmKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
        width: 570,
        marginLeft: "auto",
        space: "center",
        py: "32px",
        position: "sticky",
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, .9)",
        children: [
            !isFirstStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, SeqConsultControls_objectSpreadProps(SeqConsultControls_objectSpread({
                type: "button",
                "data-cypress-element": "data-prev-button",
                width: 120,
                emphasis: "medium",
                size: "lg",
                onClick: handlePrev,
                mr: "8px"
            }, tracking/* default.tagGTM */.Z.tagGTM(prevButtonGtmKey)), {
                children: "이전"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewContentButton */.C_, SeqConsultControls_objectSpreadProps(SeqConsultControls_objectSpread({
                type: "submit",
                "data-cypress-element": "seq-next-button",
                id: seq_consult/* SEQ_CONSULT_NEXT_BUTTON_ID */.ZF,
                width: 280,
                emphasis: "high",
                size: "lg",
                disabled: disabledNextStep(),
                onClick: handleNext
            }, tracking/* default.tagGTM */.Z.tagGTM(nextButtonGtmKey)), {
                children: isLastStep ? "상담신청" : "다음"
            }))
        ]
    });
};
/* harmony default export */ var SeqConsult_SeqConsultControls = (SeqConsultControls);

// EXTERNAL MODULE: ./src/constants/index.ts + 7 modules
var constants = __webpack_require__(5445);
;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/SeqConsult.tsx
function SeqConsult_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SeqConsult_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SeqConsult_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SeqConsult_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SeqConsult_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SeqConsult_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SeqConsult_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SeqConsult_templateObject() {
    var data = SeqConsult_taggedTemplateLiteral([
        "\n    position: relative;\n    height: 2px;\n    background-color: ",
        ";\n    content: ' ';\n    overflow: hidden;\n    display: ",
        ";\n    flex-grow: 1;\n    flex-basis: 1;\n    flex-shrink: 0;\n    &::after {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      width: ",
        "%;\n      height: 2px;\n      background-color: ",
        ";\n      content: ' ';\n      transition: all 0.3s ease;\n    }\n  "
    ]);
    SeqConsult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SeqConsult_templateObject1() {
    var data = SeqConsult_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    SeqConsult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var SeqConsult = function() {
    var ref = hooks_useSeqConsult(), hookForm = ref.hookForm, step = ref.step, stepTitle = ref.stepTitle, currentStepIndex = ref.currentStepIndex, totalStepLength = ref.totalStepLength, handleChangeStep = ref.handleChangeStep, handleNext = ref.handleNext, handlePrev = ref.handlePrev, handleSubmit = ref.handleSubmit, userBasicInfo = ref.userBasicInfo, defaultRadio = ref.defaultRadio, handleChangeIsDefaultAddress = ref.handleChangeIsDefaultAddress, stepBannerSrc = ref.stepBannerSrc, handleChangeTelCertificated = ref.handleChangeTelCertificated, isTelCertificated = ref.isTelCertificated, agentEmployeeNo = ref.agentEmployeeNo, workAvailableAreas = ref.workAvailableAreas, isOpenWorkableBottomSheet = ref.isOpenWorkableBottomSheet, handleOpenBottomSheet = ref.handleOpenBottomSheet, handleCloseBottomSheet = ref.handleCloseBottomSheet, consultType = ref.consultType;
    var handlePushAndRemove = (0,useDataLayer/* useDataLayer */.P)().handlePushAndRemove;
    var logCustomEvent = (0,BrazeProvider/* useBraze */._)().logCustomEvent;
    var isMatchType = consultType === "MATCH";
    (0,react.useEffect)(function() {
        var _obj;
        handlePushAndRemove({
            data: (_obj = {
                event: constants/* GTM_CTA_REMO_EVENT_NAME */.EK6
            }, SeqConsult_defineProperty(_obj, constants/* GTM_CTA_KEY_NAME */.H7g, constants/* GTM_CSTT */.BF4), SeqConsult_defineProperty(_obj, constants/* GTM_CST_KEYWORD */.GjS, isMatchType ? constants/* GTM_MATCH_CONSULT_KEYWORD */.vum : constants/* GTM_SEQ_CONSULT_KEYWORD */.bxv), SeqConsult_defineProperty(_obj, "gtmKeyword", isMatchType ? constants/* GTM_MATCH_CONSULT_VIEW_KEYNAME */.tLC : constants/* GTM_SEQ_CONSULT_VIEW_KEYNAME */.UnN), _obj),
            key: constants/* GTM_CTA_KEY_NAME */.H7g
        });
        logCustomEvent({
            eventName: "bz_start_fastconsult",
            eventProperties: {
                bz_date: (0,format/* default */.Z)(new Date(), "yyyy-MM-dd"),
                bz_consultType: "sequential"
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsultProvider, {
        value: {
            step: step,
            currentStepIndex: currentStepIndex,
            consultType: consultType,
            handleChangeStep: handleChangeStep,
            handleNext: handleNext,
            handlePrev: handlePrev,
            handleSubmit: handleSubmit,
            userBasicInfo: userBasicInfo,
            defaultRadio: defaultRadio,
            handleChangeIsDefaultAddress: handleChangeIsDefaultAddress,
            handleChangeTelCertificated: handleChangeTelCertificated,
            isTelCertificated: isTelCertificated,
            agentEmployeeNo: agentEmployeeNo,
            workAvailableAreas: workAvailableAreas,
            isOpenWorkableBottomSheet: isOpenWorkableBottomSheet,
            handleOpenBottomSheet: handleOpenBottomSheet,
            handleCloseBottomSheet: handleCloseBottomSheet
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, SeqConsult_objectSpreadProps(SeqConsult_objectSpread({}, hookForm), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                as: "form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                        space: 112,
                        alignment: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                width: 488,
                                height: 600,
                                position: "sticky",
                                top: styles/* HEADER_HEIGHT */.Mz + 60,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                    src: stepBannerSrc
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                width: 570,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        variant: "subTitle6",
                                        color: "color_chip.gray.600",
                                        children: "인테리어 상담신청"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                                        mb: "28px",
                                        children: [
                                            step === "personal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                mt: "16px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                                                    src: (0,utils/* getAsset */.Nh)("/assets/images/seq-consult/personal/top_banner.png")
                                                })
                                            }),
                                            step !== "personal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                variant: "headline2",
                                                color: "color_chip.primary",
                                                mt: "8px",
                                                children: stepTitle(step)
                                            }),
                                            step === "baseConstructionPlan.scopes" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "body1_5",
                                                        color: "color_chip.primary",
                                                        mt: "8px",
                                                        mb: "4px",
                                                        children: '특정 공간 내 상품 부분교체만 원하시는 경우 "기타 입력"으로 신청해주세요.'
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "caption3",
                                                        color: "color_chip.gray.700",
                                                        children: "예시) 싱크대 수전, 아일랜드장, 양변기, 도배/마루(거실만) 등"
                                                    })
                                                ]
                                            }),
                                            step === "baseConstructionPlan.budget" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body1_5",
                                                    color: "color_chip.primary",
                                                    mt: "8px",
                                                    children: "예산 선택 시 더 정확한 상담이 가능해요. (상담 시 변경 가능)"
                                                })
                                            }),
                                            step === "baseConstructionPlan.desiredDay" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body1_5",
                                                    color: "color_chip.primary",
                                                    mt: "8px",
                                                    children: "(신청일 기준)"
                                                })
                                            }),
                                            step === "baseConstructionPlan.consultSchedule" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                    variant: "body1_5",
                                                    color: "color_chip.primary",
                                                    mt: "8px",
                                                    children: "디자이너와 직접 만나서 상담을 받으실 수 있는 일정을 선택해주세요."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 16,
                                        alignment: "center",
                                        mb: "48px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                                now: currentStepIndex + 1,
                                                max: totalStepLength
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                space: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "subTitle6",
                                                        color: "color_chip.primary",
                                                        children: currentStepIndex + 1
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "subTitle6",
                                                        color: "color_chip.gray.600",
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                        variant: "subTitle6",
                                                        color: "color_chip.gray.600",
                                                        children: totalStepLength
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultQuestion, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsultControls, {})
                ]
            })
        }))
    });
};
/* harmony default export */ var SeqConsult_SeqConsult = (SeqConsult);
var ProgressBar = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "SeqConsult__ProgressBar",
    componentId: "sc-e00542bf-0"
})(SeqConsult_templateObject1(), function(param) {
    var now = param.now, max = param.max, theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SeqConsult_templateObject(), theme.colors.color_chip.gray[100], max <= 1 ? "none" : "block", Math.ceil(1 / max * 100) * now, theme.colors.color_chip.gray[700]);
});

;// CONCATENATED MODULE: ./src/feat-components/SeqConsult/index.tsx


;// CONCATENATED MODULE: ./pages/seq-consult/index.tsx




var SeqConsultPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeqConsult_SeqConsult, {})
    });
};
/* harmony default export */ var pages_seq_consult = (SeqConsultPage);


/***/ }),

/***/ 14657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Grid_Grid; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/components/Grid/Grid.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n\n    > * {\n      width: calc((100% - ",
        "px) / ",
        ") !important;\n      margin-bottom: ",
        "px;\n      margin-right: ",
        "px;\n    }\n    > *:nth-child(",
        "n) {\n      margin-right: 0;\n    }\n\n    > *:nth-last-child(-n + ",
        ") {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



/**
 * Grid 형태의 컬럼을 나타낼떄 사용
 * @author 이현우
 * @param param0
 * @returns
 */ var Grid = function(_param) {
    var children = _param.children, _colGap = _param.colGap, colGap = _colGap === void 0 ? 8 : _colGap, _rowGap = _param.rowGap, rowGap = _rowGap === void 0 ? 8 : _rowGap, colSize = _param.colSize, props = _objectWithoutProperties(_param, [
        "children",
        "colGap",
        "rowGap",
        "colSize"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, _objectSpreadProps(_objectSpread({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            colGap: colGap,
            rowGap: rowGap,
            colSize: colSize,
            children: children
        })
    }));
};
/* harmony default export */ var Grid_Grid = (Grid);
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Grid__Box",
    componentId: "sc-999e3fa9-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Grid__Container",
    componentId: "sc-999e3fa9-1"
})(_templateObject2(), function(param) {
    var _colGap = param.colGap, colGap = _colGap === void 0 ? 8 : _colGap, _rowGap = param.rowGap, rowGap = _rowGap === void 0 ? 8 : _rowGap, colSize = param.colSize;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), colGap * (colSize - 1), colSize, rowGap, colGap, colSize, colSize);
});

;// CONCATENATED MODULE: ./src/components/Grid/index.tsx
/* 작성자 : 이현우 */ 



/***/ }),

/***/ 20559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FL": function() { return /* binding */ MATCH_CONSULT_DATA; },
/* harmony export */   "LU": function() { return /* binding */ CONSULT_TYPE_DATA; },
/* harmony export */   "QB": function() { return /* binding */ CONSULT_NAME_PATTERN; },
/* harmony export */   "ZF": function() { return /* binding */ SEQ_CONSULT_NEXT_BUTTON_ID; },
/* harmony export */   "gn": function() { return /* binding */ SPACE_SCOPES; },
/* harmony export */   "iK": function() { return /* binding */ CERTIFY_ERROR_MESSAGE; },
/* harmony export */   "k_": function() { return /* binding */ SEQ_CONSULT_DATA; }
/* harmony export */ });
/* unused harmony exports SITE_BUILDING_TYPE, SITE_HOUSE_NMPG, SPACE_STATUS, CONSULT_PURPOSE, BUDGET, DESIRED_DAY, CONSULT_SCHEDULE, AGE, CONSULT_EXPERIENCE, OPINION_REFLECT, COMMUNICATION_STYLE, BUDGET_OPTION, PERSONAL */
var SEQ_CONSULT_NEXT_BUTTON_ID = "seq-next-button";
var CONSULT_NAME_PATTERN = "^[a-zA-Z가-힣\\s]{1,20}$";
var SITE_BUILDING_TYPE = {
    gtmKey: "type",
    title: "인테리어가 필요한 공간은 어디인가요?",
    autoNext: true,
    data: [
        {
            name: "아파트",
            value: "HT_001"
        },
        {
            name: "빌라",
            value: "HT_002"
        },
        {
            name: "단독주택",
            value: "HT_004"
        },
        {
            name: "오피스텔",
            value: "HT_005"
        }, 
    ]
};
var SITE_HOUSE_NMPG = {
    gtmKey: "py",
    title: "인테리어 공간의 평수를 선택해주세요.",
    autoNext: true,
    data: [
        {
            name: "10~20평대",
            value: "TEN"
        },
        {
            name: "30평대",
            value: "THIRTY"
        },
        {
            name: "40평대",
            value: "FORTY"
        },
        {
            name: "50평대 이상",
            value: "FIFTY"
        }, 
    ]
};
var SPACE_STATUS = {
    gtmKey: "status",
    title: "인테리어 할 집은 어떤 상태인가요?",
    autoNext: true,
    data: [
        {
            name: "짐보관 후 살면서 공사예정",
            value: "ME"
        },
        {
            name: "현재 공실",
            value: "EMPTY"
        },
        {
            name: "시공 시 공실 예정",
            value: "TOBEEMPTY"
        },
        {
            name: "신축입주",
            value: "MOVEIN"
        },
        {
            name: "기타 (부동산 미계약 상태)",
            value: "ETC"
        }, 
    ]
};
var CONSULT_PURPOSE = {
    gtmKey: "purpose",
    title: "인테리어를 고려하시게 된 주요 이유를 선택해주세요.",
    autoNext: true,
    data: [
        {
            name: "집을 구매하여 리모델링 계획 중",
            value: "CPT01"
        },
        {
            name: "사는 집을 새롭게 바꾸기 위해",
            value: "CPT02"
        },
        {
            name: "매매나 임대를 위한 리모델링",
            value: "CPT03"
        },
        {
            name: "기타",
            value: "CPT04"
        }, 
    ]
};
var SPACE_SCOPES = {
    gtmKey: "range",
    title: "인테리어가 필요한 공간을 모두 골라주세요.",
    autoNext: false,
    data: [
        {
            name: "키친",
            value: "KITCHEN"
        },
        {
            name: "바스",
            value: "BATH"
        },
        {
            name: "수납",
            value: "STORAGE"
        },
        {
            name: "마루",
            value: "FLOOR"
        },
        {
            name: "중문",
            value: "CENTRAL_DOOR"
        },
        {
            name: "도어",
            value: "DOOR"
        },
        {
            name: "창호",
            value: "WINDOW"
        },
        {
            name: "필름",
            value: "FILM"
        },
        {
            name: "벽지",
            value: "WALLPAPER"
        },
        {
            name: "조명",
            value: "LIGHT"
        },
        {
            name: "타일",
            value: "TILE"
        },
        {
            name: "기타 입력",
            value: "ETC"
        }, 
    ]
};
var BUDGET = {
    gtmKey: "budget",
    title: "인테리어 예산은 총 얼마를 생각하시나요?",
    autoNext: true,
    data: [
        {
            name: "5백만원 이하",
            value: 500
        },
        {
            name: "1천만원 이하",
            value: 1000
        },
        {
            name: "2천만원 이하",
            value: 2000
        },
        {
            name: "3천만원 이하",
            value: 3000
        },
        {
            name: "4천만원 이하",
            value: 4000
        },
        {
            name: "5천만원 이하",
            value: 5000
        },
        {
            name: "6천만원 이하",
            value: 6000
        },
        {
            name: "7천만원 이하",
            value: 7000
        },
        {
            name: "1억원 이하",
            value: 10000
        },
        {
            name: "아직 미정이에요",
            value: 0
        }, 
    ]
};
var DESIRED_DAY = {
    gtmKey: "date",
    title: "인테리어가 언제 시작되길 희망하시나요?",
    autoNext: true,
    data: [
        {
            name: "1개월 이내",
            value: "BEFORE_1_MONTH"
        },
        {
            name: "2개월 이내",
            value: "BEFORE_2_MONTH"
        },
        {
            name: "3개월 이내",
            value: "BEFORE_3_MONTH"
        },
        {
            name: "3개월 이후",
            value: "AFTER_3_MONTH"
        },
        {
            name: "6개월 이후",
            value: "AFTER_6_MONTH"
        }, 
    ]
};
var CONSULT_SCHEDULE = {
    gtmKey: "call",
    title: "원하시는 상담 일정을 알려주세요.",
    autoNext: true,
    data: [
        {
            name: "가능한 빨리",
            value: "ASAP"
        },
        {
            name: "10일 이내",
            value: "BEFORE_10_DAY"
        },
        {
            name: "한달 이내",
            value: "BEFORE_1_MONTH"
        },
        {
            name: "한달 이후",
            value: "AFTER_1_MONTH"
        }, 
    ]
};
var AGE = {
    gtmKey: "age",
    title: "고객님의 연령대를 알려주세요.",
    autoNext: true,
    data: [
        {
            name: "20~30대",
            value: "30"
        },
        {
            name: "40대",
            value: "40"
        },
        {
            name: "50대",
            value: "50"
        },
        {
            name: "60대 이상",
            value: "60"
        }, 
    ]
};
var CONSULT_EXPERIENCE = {
    gtmKey: "count",
    title: "인테리어 상담을 받아보신 적 있나요?",
    autoNext: true,
    data: [
        {
            name: "없음",
            value: "EXP01"
        },
        {
            name: "1~2회",
            value: "EXP02"
        },
        {
            name: "3회 이상",
            value: "EXP03"
        }, 
    ]
};
var OPINION_REFLECT = {
    gtmKey: "feedback",
    title: "고객님의 의견이  어느 정도 반영되길 원하시나요?",
    autoNext: true,
    data: [
        {
            name: "주로 나의 의견이 반영되기를",
            value: "OPIN01"
        },
        {
            name: "전문가의 추천에 따라 조율하기를",
            value: "OPIN02"
        },
        {
            name: "전문가가 알아서 제안해주기를",
            value: "OPIN03"
        }, 
    ]
};
var COMMUNICATION_STYLE = {
    gtmKey: "approach",
    title: "전문가와 의견을 나눌 때 어떤 방식이 더 편안하실까요?",
    autoNext: true,
    data: [
        {
            name: "하나씩 자주 연락하며 진행하는 방식",
            value: "COMSTL01"
        },
        {
            name: "정리된 내용으로 한 번에 조율하는 방식",
            value: "COMSTL02"
        }, 
    ]
};
var BUDGET_OPTION = {
    gtmKey: "option",
    title: "예산과 상품구성은 어떻게 진행되길 원하시나요?",
    autoNext: true,
    data: [
        {
            name: "예산을 초과하지 않은 효율적인 구성",
            value: "BDGTOPT01"
        },
        {
            name: "추천 구성에 따라 소폭 예산 조정",
            value: "BDGTOPT02"
        },
        {
            name: "예산보다 품질 중심의 제안 우선 고려",
            value: "BDGTOPT03"
        }, 
    ]
};
// 'site.address': {
//   gtmKey: 'addr',
//   title: '시공할 주소를 입력해 주세요.',
//   autoNext: false,
//   data: null,
// },
var PERSONAL = {
    gtmKey: "privacy",
    title: null,
    autoNext: false,
    data: null
};
// 시퀀셜 상담 신청
var SEQ_CONSULT_DATA = {
    "site.buildingType": SITE_BUILDING_TYPE,
    "site.houseNMPG": SITE_HOUSE_NMPG,
    "baseConstructionPlan.spaceStatus": SPACE_STATUS,
    "baseConstructionPlan.consultPurpose": CONSULT_PURPOSE,
    "baseConstructionPlan.scopes": SPACE_SCOPES,
    "baseConstructionPlan.budget": BUDGET,
    "baseConstructionPlan.desiredDay": DESIRED_DAY,
    "baseConstructionPlan.consultSchedule": CONSULT_SCHEDULE,
    personal: PERSONAL
};
// 매칭 상담 신청
var MATCH_CONSULT_DATA = {
    "baseConstructionPlan.age": AGE,
    "site.buildingType": SITE_BUILDING_TYPE,
    "site.houseNMPG": SITE_HOUSE_NMPG,
    "baseConstructionPlan.spaceStatus": SPACE_STATUS,
    "baseConstructionPlan.consultPurpose": CONSULT_PURPOSE,
    "baseConstructionPlan.consultExperience": CONSULT_EXPERIENCE,
    "baseConstructionPlan.opinionReflect": OPINION_REFLECT,
    "baseConstructionPlan.communicationStyle": COMMUNICATION_STYLE,
    "baseConstructionPlan.scopes": SPACE_SCOPES,
    "baseConstructionPlan.budget": BUDGET,
    "baseConstructionPlan.budgetOption": BUDGET_OPTION,
    "baseConstructionPlan.desiredDay": DESIRED_DAY,
    "baseConstructionPlan.consultSchedule": CONSULT_SCHEDULE,
    personal: PERSONAL
};
// 상담 유형
var CONSULT_TYPE_DATA = {
    SEQ: SEQ_CONSULT_DATA,
    MATCH: MATCH_CONSULT_DATA
};
var CERTIFY_ERROR_MESSAGE = {
    INACCURATE: "인증번호를 정확히 입력해 주세요.",
    TIME_EXPIRED: "인증시간이 만료 되었습니다. 다시 시도해 주세요.",
    EXCEEDED: "인증번호를 더 이상 전송 할 수 없습니다."
};


/***/ }),

/***/ 30694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CONSULT_TYPES; },
/* harmony export */   "O": function() { return /* binding */ SEQ_CONSULT_KAKAO_TEMPLATE_CODE; }
/* harmony export */ });
var CONSULT_TYPES = {
    SEQ: "SEQ",
    MATCH: "MATCH"
};
var SEQ_CONSULT_KAKAO_TEMPLATE_CODE = "AT_20240829154432";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,8974,9046,6996,378,4945,4702,3651,1376,5262,7072,9774,2888,179], function() { return __webpack_exec__(22085); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);